<template>
    <div>

      <div class="mb-4">
        <div class="font-weight-bold">
          Exclude words
        </div>
        <div class="mt-2">Exclude specific words or phrases you don't want to appear in your web page.</div>
      </div>

      <div>
        <div>
          <multiselect
            class="exclude-terms-multiselect"
            :value="excludeTerms"
            :options="[]"
            :multiple="true"
            :taggable="true"
            :hide-selected="true"
            placeholder="cheap, best, guaranteed, conclusion, embark, final thoughts"
            tag-placeholder="Press enter to add"
            @tag="addNewExcludeTerm"
            @remove="handleRemoveExcludeTerm"
          >
          </multiselect>
        </div>
      </div>

    </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
    name: 'ConfigExcludeTerms',
    components: {
      Multiselect
    },
    props: [

        'addNewExcludeTerm',
        'handleRemoveExcludeTerm',
        'excludeTerms',
    ],
}
</script>

<style lang="scss" scoped>
::v-deep {
  .exclude-terms-multiselect {
    ul.multiselect__content {
      margin-top: 0;
      margin-left: 0;
    }
  }
}
</style>